import { graphql, useStaticQuery } from 'gatsby';

/**
 *  Provides CMS data without modifying it.
 */
export const useCmsData = () => {
	const {
		courseTypes: { edges: courseTypes },
		courses: { edges: courses },
		digitalizationPages: { edges: digitalizationPages },
		firmenschulungenPage,
		authors: { edges: authors },
	} = useStaticQuery(graphql`
		query useCmsDataQuery {
			digitalizationPages: allMarkdownRemark(
				filter: { fileAbsolutePath: { regex: "//content/digitalisierung//" } }
			) {
				edges {
					node {
						id
						frontmatter {
							uuid
							slug
							title
							navigationTitle
							parent

							events {
								uuid
								start
								end
								title
								content
							}
						}
					}
				}
			}
			courseTypes: allMarkdownRemark(
				filter: { fileAbsolutePath: { regex: "//content/kurstypen//" } }
			) {
				edges {
					node {
						id
						frontmatter {
							uuid
							slug
							title
						}
					}
				}
			}
			courses: allMarkdownRemark(filter: { fileAbsolutePath: { regex: "//content/kurse//" } }) {
				edges {
					node {
						id
						frontmatter {
							uuid
							seo {
								description
							}
							courseType
							slug
							menuTitle
							title
							contentList
							durationDays
							durationHours
							price
							appointments {
								start
								end
								location
							}
						}
					}
				}
			}
			firmenschulungenPage: markdownRemark(
				fileAbsolutePath: { regex: "/seiten/firmenschulungen.md/" }
			) {
				id
				frontmatter {
					slug
					sections {
						title
					}
				}
			}

			authors: allMarkdownRemark(
				filter: { fileAbsolutePath: { regex: "//content/blog/authors//" } }
			) {
				edges {
					node {
						id
						frontmatter {
							uuid
							name
							description
							image {
								image {
									publicURL
									extension
									childImageSharp {
										gatsbyImageData(width: 120, height: 120, layout: FIXED)
									}
								}
								title
								alt
							}
						}
					}
				}
			}
		}
	`);

	return {
		courseTypes,
		courses,
		digitalizationPages,
		firmenschulungenPage,
		authors,
	};
};
